var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":_vm.$t('components.WebsitesStats.TotalUsersByCountry'),"loading":_vm.loading}},[_c('ListChart',{attrs:{"items":_vm.topLocations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }